module.exports = __webpack_public_path__ + "media/70_Long.78856a2e.mp3";